import { render } from "./CallAudioDownloadButton.vue?vue&type=template&id=b1a9fa56&ts=true"
import script from "./CallAudioDownloadButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./CallAudioDownloadButton.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/call/components/CallAudioDownloadButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b1a9fa56"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b1a9fa56', __exports__)) {
    api.reload('b1a9fa56', __exports__)
  }
  
  module.hot.accept("./CallAudioDownloadButton.vue?vue&type=template&id=b1a9fa56&ts=true", () => {
    api.rerender('b1a9fa56', render)
  })

}


export default __exports__